<!--
  ~ Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<bci-sidebar-nav-item-overlay (close)="close()">
  <div class="bci-sidebar-nav-item-overlay-header">
    <span>{{ config?.description }}</span>
  </div>
  <div class="bci-sidebar-nav-item-overlay-buttons">
    <button class="button-primary" (click)="logout()">
      {{ config?.title }}
    </button>
  </div>
</bci-sidebar-nav-item-overlay>
